import i18n from '../../i18n/config';

import { LANGUAGES_OPTIONS } from './constants';

export const getDefaultLanguage = () => {
  const languageId = i18n.language.toUpperCase();
  return LANGUAGES_OPTIONS.find((lang) => lang.id === languageId) || LANGUAGES_OPTIONS[0];
};
